import type { OnboardingState } from '@/services/onboardingService';

export type BotStatus = 'setup' | 'preview_tested' | 'connected' | 'live';

export const TOTAL_STEPS = 5;

export function deriveBotStatus(state: OnboardingState | null): BotStatus {
  if (!state) return 'setup';
  if (state.current_step === 'completed') return 'live';
  if (state.meta_oauth_completed_at) return 'connected';
  if (state.preview_completed_at) return 'preview_tested';
  return 'setup';
}

export function completedStepCount(state: OnboardingState | null): number {
  if (!state) return 0;
  return (
    Number(!!state.info_completed_at) +
    Number(!!state.kb_completed_at) +
    Number(!!state.preview_completed_at) +
    Number(!!state.meta_oauth_completed_at) +
    Number(!!state.stripe_completed_at)
  );
}
